import React from "react";

export function StatusBadge({ status }) {
  const key = (status || "").toLowerCase().replace(/\s+/g, "-");
  const label = status
    ? String(status).replace(/_/g, " ").replace(/\b\w/g, (character) => character.toUpperCase())
    : "Unknown";
  return (
    <span className={`mg-status mg-status-${key}`} data-testid={`status-badge-${key}`}>
      {label}
    </span>
  );
}

export function EmptyState({ title, message, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      <div className="opacity-50 mb-4">
        {/* Inline reuse of Mascot would require import — use a span */}
        <div className="w-20 h-20 rounded-full mg-gradient-primary opacity-20 animate-pulse" />
      </div>
      <h3 className="text-lg font-bold text-mg-navy mb-1">{title}</h3>
      <p className="text-sm text-slate-500 max-w-md mb-4">{message}</p>
      {action}
    </div>
  );
}

export function StatCard({ label, value, hint, icon, color = "mg-medical", testid }) {
  return (
    <div className="mg-card mg-fade-in" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
          <div className="text-2xl font-extrabold text-mg-navy mt-1">{value}</div>
          {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
        </div>
        {icon && (
          <div className={`w-10 h-10 rounded-xl bg-${color}/10 flex items-center justify-center text-${color}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}

export function CommonModal({ title, onClose, onSave, children, saveText = "Save" }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full my-8">
        <h3 className="font-bold text-mg-navy text-lg mb-4">{title}</h3>
        {children}
        <div className="flex gap-2 mt-5">
          <button onClick={onClose} className="mg-btn-secondary flex-1 justify-center" data-testid="modal-cancel-btn">Cancel</button>
          <button onClick={onSave} className="mg-btn-primary flex-1 justify-center" data-testid="modal-save-btn">{saveText}</button>
        </div>
      </div>
    </div>
  );
}
